module.exports = __webpack_public_path__ + "static/img/faq-icon.92a29053.svg";